import { createContext } from 'react';

export type SlotContextValue = {
  slots: Record<string, string[]> | null | undefined;
  slotInstructions?: Record<string, string> | null;
  readOnly?: boolean;
  onSlotClick: (slotName: string) => void;
  onSlotCreate: (slotName: string, firstValue: string) => void;
};

export const SlotContext = createContext<SlotContextValue>({
  slots: undefined,
  slotInstructions: undefined,
  readOnly: false,
  onSlotClick: () => {},
  onSlotCreate: () => {},
});
